import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Checkbox,
  Label,
  TextArea,
  Input
} from 'semantic-ui-react'

const CardSurgicalSafetyChecklistSigninUX = (props: any) => {
    return(
      <div
        id="CardSurgicalSafetyChecklistSigninUX-div-0"
        style={{ margin: "15px", padding: "20px", backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-125"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-126"
              style={{ fontWeight: "bold", fontSize: "18px" }}>
              {props.languageUX === "en" ? "Surgical Safety Checklist - Sign in" : "Surgical Safety Checklist - Sign in"}
            </label>
            <Label
              id="CardSurgicalSafetyChecklistSigninUX-Label-127"
              style={{display: props.status? "": "none"}}>
              {props.status}
            </Label>
          </div>
          <hr
            id="CardSurgicalSafetyChecklistSigninUX-hr-4">
          </hr>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-5"
          style={{ display: "flex", paddingBottom: "5px", fontWeight: "bold" }}>
          
          <label
            id="CardSurgicalSafetyChecklistSigninUX-label-8"
            style={{ width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Does Patient have a:" : "ผู้ป่วยมี:"}
          </label>
          <label
            id="CardSurgicalSafetyChecklistSigninUX-label-47">
            {props.previous_operating}
          </label>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-77"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-78"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-79">
              {props.languageUX === "en" ? "Patient Identify" : "การยืนยันตัวตนผู้ป่วย"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-80"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.patient_identify}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-81"
            label={props.surgicalSafety?.data?.patient_identify ? "Yes" : "No"}
            onChange={props.handleChangeValue("patient_identify")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-82"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-83"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-84">
              {props.languageUX === "en" ? "Site Marked" : "ทำเครื่องหมายบริเวณผ่าตัด"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-85"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.site_marked}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-86"
            label={props.surgicalSafety?.data?.site_marked ? "Applicable" : "Not applicable"}
            onChange={props.handleChangeValue("site_marked")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-87"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-88"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-89">
              {props.languageUX === "en" ? "Known allergy" : "อาการแพ้ที่ทราบ"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-90"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.know_allergy}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-91"
            label={props.surgicalSafety?.data?.know_allergy ? "Yes" : "No"}
            onChange={props.handleChangeValue("know_allergy")}
            toggle={true}>
          </Checkbox>
          <Input
            id="CardSurgicalSafetyChecklistSigninUX-Input-135"
            name="allergyRemark"
            onChange={props.handleChangeValue("allergyRemark")}
            style={{ width: "30%", margin: "0px 30px",  ...(!props.surgicalSafety?.data?.know_allergy && { display: "none" })  }}
            value={props.surgicalSafety?.data?.allergyRemark}>
          </Input>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-92"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-93"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-94">
              {props.languageUX === "en" ? "Anesthesia safety check complete" : "การประเมินความปลอดภัยของการระงับความรู้สึกเสร็จสมบูรณ์"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-95"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.anesthesia_check}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-96"
            label={props.surgicalSafety?.data?.anesthesia_check ? "Yes" : "No"}
            onChange={props.handleChangeValue("anesthesia_check")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-97"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-98"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-99">
              {props.languageUX === "en" ? "Difficult airway/aspiration risk" : "ความเสี่ยงต่อการจัดการทางเดินหายใจ/การสำลัก"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-100"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.airway_risk}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-101"
            label={props.surgicalSafety?.data?.airway_risk ? "Yes" : "No"}
            onChange={props.handleChangeValue("airway_risk")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-102"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-103"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-104">
              {props.languageUX === "en" ? "Pulse Oximeter on patient and functioning" : "เครื่องวัดออกซิเจนต่อผู้ป่วยและพร้อมใช้งาน"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-105"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.pulse_oximeter}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-106"
            label={props.surgicalSafety?.data?.pulse_oximeter ? "Yes" : "No"}
            onChange={props.handleChangeValue("pulse_oximeter")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-107"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-108"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-109">
              {props.languageUX === "en" ? "Risk of > 500ml blood loss (7 ml/kg in children)" : "ความเสี่ยงการเสียเลือด > 500 มล. (เด็ก 7 มล./กก.)"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-110"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.risk}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-111"
            label={props.surgicalSafety?.data?.risk ? "Yes" : "No"}
            onChange={props.handleChangeValue("risk")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-112"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-113"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-114">
              {props.languageUX === "en" ? "Special instrument and Implant check completed" : "การตรวจสอบอุปกรณ์พิเศษและ อุปกรณ์ฝังในร่างกายเสร็จสมบูรณ์"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-115"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.special_instrument}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-116"
            label={props.surgicalSafety?.data?.special_instrument ? "Yes" : "No"}
            onChange={props.handleChangeValue("special_instrument")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          className="ui form"
          style={{ display: "flex", paddingBottom: "5px" , width: "100%"}}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-118"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-119">
              {props.languageUX === "en" ? "Blood component" : "Blood component"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-120"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.blood}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-121"
            label={props.surgicalSafety?.data?.blood ? "Yes" : "No"}
            onChange={props.handleChangeValue("blood")}
            toggle={true}>
          </Checkbox>
          <TextArea
            id="CardSurgicalSafetyChecklistSigninUX-TextArea-134"
            name="bloodRemark"
            onChange={props.handleChangeValue("bloodRemark")}
            style={{ width: "30%", margin: "0px 30px", ...(!props.surgicalSafety?.data?.blood && { display: "none" }) }}
            value={props.surgicalSafety?.data?.bloodRemark}>
          </TextArea>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-122"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-136"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-138">
              {props.languageUX === "en" ? "Blood component available" : "Blood component available"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistSigninUX-label-139"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.blood_available}
            id="CardSurgicalSafetyChecklistSigninUX-Checkbox-137"
            label={props.surgicalSafety?.data?.blood_available? "Yes" : "No"}
            onChange={props.handleChangeValue("blood_available")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistSigninUX-div-59"
          style={{ height: "55px", paddingTop: "15px", display: "flex", justifyContent: "flex-end" }}>
          
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-131">
            {props.buttonSave}
          </div>
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-132"
            style={{margin: "0px 10px"}}>
            {props.buttonConfirm}
          </div>
          <div
            id="CardSurgicalSafetyChecklistSigninUX-div-133">
            {props.buttonUnconfirm}
          </div>
        </div>
      </div>
    )
}


export default CardSurgicalSafetyChecklistSigninUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\", padding: \"20px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-hr-4"
        }
      },
      "seq": 125,
      "void": true
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\", fontWeight: \"bold\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยมี:",
          "valueEN": "Does Patient have a:"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.previous_operating"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\", display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "การยืนยันตัวตนผู้ป่วย",
          "valueEN": "Patient Identify"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-79"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Checkbox",
      "parent": 77,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.patient_identify"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-81"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.patient_identify ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"patient_identify\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "ทำเครื่องหมายบริเวณผ่าตัด",
          "valueEN": "Site Marked"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-84"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Checkbox",
      "parent": 82,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.site_marked"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-86"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.site_marked ? \"Applicable\" : \"Not applicable\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"site_marked\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "อาการแพ้ที่ทราบ",
          "valueEN": "Known allergy"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-89"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-90"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Checkbox",
      "parent": 87,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.know_allergy"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-91"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.know_allergy ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"know_allergy\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินความปลอดภัยของการระงับความรู้สึกเสร็จสมบูรณ์",
          "valueEN": "Anesthesia safety check complete"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-94"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-95"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Checkbox",
      "parent": 92,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.anesthesia_check"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-96"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.anesthesia_check ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"anesthesia_check\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเสี่ยงต่อการจัดการทางเดินหายใจ/การสำลัก",
          "valueEN": "Difficult airway/aspiration risk"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-99"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-100"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Checkbox",
      "parent": 97,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.airway_risk"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-101"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.airway_risk ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"airway_risk\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "เครื่องวัดออกซิเจนต่อผู้ป่วยและพร้อมใช้งาน",
          "valueEN": "Pulse Oximeter on patient and functioning"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-104"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-105"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Checkbox",
      "parent": 102,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.pulse_oximeter"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-106"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.pulse_oximeter ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"pulse_oximeter\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-107"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 107,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเสี่ยงการเสียเลือด > 500 มล. (เด็ก 7 มล./กก.)",
          "valueEN": "Risk of > 500ml blood loss (7 ml/kg in children)"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-109"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-110"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Checkbox",
      "parent": 107,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.risk"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-111"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.risk ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"risk\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-113"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจสอบอุปกรณ์พิเศษและ อุปกรณ์ฝังในร่างกายเสร็จสมบูรณ์",
          "valueEN": "Special instrument and Implant check completed"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-114"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-115"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Checkbox",
      "parent": 112,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.special_instrument"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-116"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.special_instrument ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"special_instrument\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" , width: \"100%\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "label",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "Blood component",
          "valueEN": "Blood component"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-119"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "label",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-120"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Checkbox",
      "parent": 117,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.blood"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-121"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.blood ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"blood\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "label",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "Surgical Safety Checklist - Sign in",
          "valueEN": "Surgical Safety Checklist - Sign in"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-126"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "Label",
      "parent": 125,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Label-127"
        },
        "style": {
          "type": "code",
          "value": "{display: props.status? \"\": \"none\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-131"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "TextArea",
      "parent": 117,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-TextArea-134"
        },
        "name": {
          "type": "value",
          "value": "bloodRemark"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"bloodRemark\")"
        },
        "rows": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"30%\", margin: \"0px 30px\", ...(!props.surgicalSafety?.data?.blood && { display: \"none\" }) }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.bloodRemark"
        }
      },
      "seq": 134,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Input",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Input-135"
        },
        "name": {
          "type": "value",
          "value": "allergyRemark"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"allergyRemark\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"30%\", margin: \"0px 30px\",  ...(!props.surgicalSafety?.data?.know_allergy && { display: \"none\" })  }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.allergyRemark"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "Checkbox",
      "parent": 122,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.blood_available"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-Checkbox-137"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.blood_available? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"blood_available\")"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "label",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "Blood component available",
          "valueEN": "Blood component available"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-138"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistSigninUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 139,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSurgicalSafetyChecklistSigninUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
